import createWebStorage from 'redux-persist/es/storage/createWebStorage';

export const storage =
    typeof window !== 'undefined'
        ? createWebStorage('local')
        : createWebStorage('memory');
